module.exports = __webpack_public_path__ + "public/Icons/MapMarker/unAvailableDrivers.png?2df79535";